export default __webpack_public_path__ + "static/media/OS_TienLen_PHONG BAN - VIE.bd869594.png";